import React from "react";
import styles from './ToggleSwitch.module.css'
import cx from "classnames";

type ToggleSwitchProps = {
    property: string
    value: boolean;
    label: string;
    onChange: (property: string, value: boolean) => void;
    classes?: string;
};

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ property, value, label, onChange, classes }) => {
    return (
        <label className={cx(styles['zr-switch'])}>
            <input
                type="checkbox"
                checked={value}
                onChange={(e) => onChange(property, e.target.checked)}
            />
            <span className={cx(styles['slider'], { [styles.checked]: value })}></span>
            <span className={cx(styles['label-text'])}>{label}</span>
        </label>
    );
}
export default ToggleSwitch;
